import { render, staticRenderFns } from "./ProcessFollowup.vue?vue&type=template&id=62ac894f&"
import script from "./ProcessFollowup.vue?vue&type=script&lang=js&"
export * from "./ProcessFollowup.vue?vue&type=script&lang=js&"
import style0 from "./ProcessFollowup.vue?vue&type=style&index=0&id=62ac894f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports